import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { MyleObjectType } from "@/Common/Models/Enum/MyleObjectType";
import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { PortalSyncStatus } from "@/Common/Models/Portal/Enums/PortalSyncStatus";
import { SharedItem } from "@/Common/Models/Portal/SharedItem/SharedItem";
import { SharedItemMessage } from "@/Common/Models/Portal/SharedItem/SharedItemMessage";
import { IPortalShareableItem } from "@/Common/Models/Portal/UI/IPortalShareableItem";

export class ShareableGrowthChartModel implements IPortalShareableItem {
    public SharedItem: SharedItem;
    public SharedItemMessages: SharedItemMessage[];

    constructor(fields?: Partial<ShareableGrowthChartModel>) {
        Object.assign(this, fields);
    }

    public getSharedItemMessages(): SharedItemMessage[] {
        this.SharedItemMessages && this.SharedItemMessages.forEach(p => {
            p.tmpIdForUI = SharedItemMessage.getTempIdForUi(p);
        });

        return this.SharedItemMessages;
    }

    public getSharedItem(): SharedItem {
        return this.SharedItem;
    }

    public getSharedItemId(): string {
        if (this && this.SharedItem)
            return this.SharedItem.SharedItemId;
        return null;
    }

    public getGlobalPortalStatus(): PortalSyncStatus {
        return PortalHelper.getGlobalPortalStatus(this.getSharedItem(), this.getSharedItemMessages());
    }

    public getItemTypeHeader(): string {
        return "";
    }

    public getItemTitle(): string {
        return `${cacheStore.GetString("GrowthChartsLabel")}`;
    }

    public getDefaultSubject(): string {
        return this.getItemTitle();
    }

    public getPortalObjectId(): string {
        return this.getSharedItemId();
    }

    public getPortalLinkedItemType(): PortalLinkedItemType {
        return PortalLinkedItemType.GrowthChart;
    }

    public getSharedItemPortalStatus(): PortalSyncStatus {
        return PortalHelper.getLinkedItemPortalStatus(this.getSharedItem());
    }

    public hasBeenModifiedSinceLastShared(): boolean {
        const medicalSummary = patientStore.PatientMedicalSummaryModels[patientStore.getCurrentPatientContactId()];
        if (!medicalSummary)
            return false;

        const latestVitalSign = medicalSummary.get("MedicalItemsVitalSign")
            ?.toArray()
            ?.filter(x => !x.EMRTemplateIsInvalid)
            ?.sortByPropertyDesc(x => x.LastUpdateDate).firstOrDefault();

        const sharedItem = this.getSharedItem();
        if (!latestVitalSign?.LastUpdateDate || !sharedItem?.LastStatusDate)
            return false;

        return new Date(sharedItem?.LastStatusDate) < new Date(latestVitalSign.LastUpdateDate);
    }

    public updateShareableModel(sharedItem: SharedItem, sharedItemMessages: SharedItemMessage[]): void {
        this.SharedItem = sharedItem;
        this.SharedItemMessages = sharedItemMessages;
        this.setSharedItemMessagesSelectStatus();
    }

    public hasBeenSharedOnPreviousEncounter(): boolean {
        return false;
    }

    public getMyleObjectType(): MyleObjectType {
        return MyleObjectType.GrowthCharts;
    }

    public setSharedItemMessagesSelectStatus(): void {
        for (let message of this.SharedItemMessages || [])
            message.IsSelected = message.Status === PortalSyncStatus.Pending || message.Status === PortalSyncStatus.Viewed;
    }
}
